import { render, staticRenderFns } from "./nearRegisterTab.vue?vue&type=template&id=ef035638"
import script from "./nearRegisterTab.vue?vue&type=script&lang=js"
export * from "./nearRegisterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef035638')) {
      api.createRecord('ef035638', component.options)
    } else {
      api.reload('ef035638', component.options)
    }
    module.hot.accept("./nearRegisterTab.vue?vue&type=template&id=ef035638", function () {
      api.rerender('ef035638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearRegisterTab.vue"
export default component.exports